import React from "react"

import { CssBaseline } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import * as Sentry from "@sentry/react"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { Provider as ReduxProvider } from "react-redux"
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom"

import { ErrorFallback } from "@/component/Error"
import { store } from "@/store"
import history from "@/util/history"

const theme = createTheme({
	palette: {
		primary: {
			main: "#144a63",
		},
		secondary: {
			main: "#e91e63",
		},
	},
})

export const AppProvider = (props: { children: React.ReactNode }) => {
	const { children } = props
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<React.Suspense fallback={<i>loading...</i>}>
				<Sentry.ErrorBoundary fallback={ErrorFallback}>
					<ReduxProvider store={store}>
						<DndProvider backend={HTML5Backend}>
							<HistoryRouter history={history}>{children}</HistoryRouter>
						</DndProvider>
					</ReduxProvider>
				</Sentry.ErrorBoundary>
			</React.Suspense>
		</ThemeProvider>
	)
}
